import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Button,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import inputValidation from '../../input-validation.service.js';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../SignUp_Login/signUp.styles';
import PhoneInput from 'react-phone-number-input';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axios from 'axios';
import _ from 'lodash';
import PanelWithImage from '../../SignUp_Login/PanelWithImage';
import logo from '../../images/logo.png';
import { isEmpty } from 'lodash';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import userService from '../../user.service';
import LoginWithGoogle from '../../components/LoginWithGoogle.jsx';
import useStore from '../../Store/Store.js';
import { signCustomToken } from '../../utils/firebase';

const useStyles = makeStyles()(styles);

const CanCareSignUp = (props) => {
  const history = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const { t } = useTranslation();
  const { classes } = useStyles();

  const [state, setState] = useState({
    firstName: '',
    lastName: '',
    phonenumber: '',
    email: '',
    password: '',
    userType: '',
    errorMessage: '',
    welcome: false,
    isEmailDisabled: false,
    isPhoneDisabled: false,
    isRadioEmailDisabled: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoader] = useState(false);
  const [param, setParam] = useState(null);
  const [token, setToken] = useState(null);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  React.useEffect(() => {
    const tempParam = query.get('token');
    setParam(tempParam);
  }, [query]);

  const getTokenData = React.useCallback(
    async (token) => {
      try {
        const { data } = await axios.get(
          process.env.REACT_APP_EXPRESS_URL + `/api/canCare/getTokenData?token=${token}`,
        );
        let email = '';
        let phone = '';
        let phoneDisabled = false;
        let emailDisabled = false;

        if (data?.data?.isEmail) {
          email = 'xxx@example.com';
          emailDisabled = true;
        } else {
          phone = '+111111111';
          phoneDisabled = true;
        }

        setToken(param);
        setState((prevState) => {
          return {
            ...prevState,
            userType: careUserType.cargiver,
            phonenumber: phone,
            email: email,
            isRadioEmailDisabled: true,
            isPhoneDisabled: phoneDisabled,
            isEmailDisabled: emailDisabled,
          };
        });
      } catch (error) {
        console.log('error =====> ', error);
      }
    },
    [param],
  );

  React.useEffect(() => {
    if (!isEmpty(param)) {
      getTokenData(param);
    }
  }, [param]);

  async function submitInfo() {
    if (
      !state.phonenumber ||
      !state.email ||
      !state.password ||
      !state.userType ||
      !state.firstName ||
      !state.lastName
    ) {
      setState((prevState) => {
        return {
          ...prevState,
          errorMessage: t('fillAllFields'),
        };
      });
    } else if (inputValidation.checkPasswordValidation(state.password) != null) {
      return setState((prevState) => {
        return {
          ...prevState,
          errorMessage: t('passwordRequirements'),
        };
      });
    } else if (!inputValidation.email(state.email)) {
      return setState((prevState) => {
        return { ...prevState, errorMessage: t('invalidEmail') };
      });
    } else {
      setLoader(true);
      try {
        const { data } = await axios.post(process.env.REACT_APP_EXPRESS_URL + '/api/canCare/signup?portal=true', {
          username: state.phonenumber,
          email: state.email,
          password: state.password,
          userInfo: {
            firstName: state.firstName,
            lastName: state.lastName,
          },
          careUserType: state.userType,
          token,
        });

        if (data?.data?.user) {
          userService.updateAuthData({
            accessToken: data?.data?.token,
            currentUserId: data?.data?.userId,
            rememberMe: true,
          });

          userService.updateStorage({
            accessToken: data?.data?.token,
            currentUserId: data?.data?.userId,
            rememberMe: true,
          });

          useStore.getState().updateUser(data?.data?.user);
          userService.updateCurrentUser(data?.data?.user);
          localStorage.setItem('auth', data?.data?.token + '~29#215@rfeqwEt0');

          // Save refresh token if available
          if (data?.data?.refreshToken) {
            localStorage.setItem('refreshToken', data.data.refreshToken);
            sessionStorage.setItem('refreshToken', data.data.refreshToken);
            console.log('✅ CanCare SignUp: Refresh token saved');
          } else {
            console.log('⚠️ CanCare SignUp: No refresh token in response');
          }

          // Sign in with Firebase custom token if available
          if (data?.data?.firebaseCustomToken) {
            try {
              const response = await signCustomToken(data.data.firebaseCustomToken);
              if (response?.user?.uid) {
                console.log('✅ CanCare SignUp: Firebase sign-in successful, UID:', response.user.uid);
              }
            } catch (error) {
              console.error('⚠️ CanCare SignUp: Firebase sign-in error:', error);
            }
          } else {
            console.log('⚠️ CanCare SignUp: No Firebase token provided');
          }

          history('/main');
        }
      } catch (err) {
        if (err?.response?.status === 429) {
          setState((prevState) => {
            return {
              ...prevState,
              errorMessage: t('tooManyRequests'),
            };
          });
          return;
        }
        setState((prevState) => {
          return {
            ...prevState,
            errorMessage: err?.response?.data?.message || t('somethingWentWrong'),
          };
        });
      } finally {
        setLoader(false);
      }
    }
  }

  const careUserType = {
    careRecipient: 'CARE_RECIPIENT',
    cargiver: 'CAREGIVER',
  };

  return (
    <>
      <Grid container direction="row" justify="space-between" alignItems="center">
        <PanelWithImage />
        <Grid item className={classes.rightPanelContainer} xs={12} md={6}>
          <div className={classes.rightPanel}>
            <div className={classes.rightPanel}>
              <div className={classes.header}>
                <div>
                  <img className={classes.logo} src={logo} alt={t('canLogoAlt')} />
                  <span style={{ marginLeft: '15px', fontSize: '60px', fontFamily: 'monospace' }}>CARE</span>
                </div>
              </div>
              {!state.welcome && (
                <form
                  className={classes.form}
                  noValidate
                  onSubmit={(e) => {
                    e.preventDefault();
                    submitInfo();
                  }}
                >
                  <Typography className={classes.mainText} component="h1" variant="h4">
                    {state.isEmailDisabled || state.isPhoneDisabled || state.isRadioEmailDisabled
                      ? t('createCaregiverAccount')
                      : t('createAccount')}
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="firstName"
                        label={t('firstName')}
                        name="firstName"
                        InputProps={{
                          className: classes.input,
                        }}
                        value={state.firstName}
                        onChange={(event) => {
                          return inputValidation.name(event, 'firstName', setState);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="lastName"
                        label={t('lastName')}
                        name="lastName"
                        InputProps={{
                          className: classes.input,
                        }}
                        value={state.lastName}
                        onChange={(event) => {
                          return inputValidation.name(event, 'lastName', setState);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl fullWidth required>
                        <InputLabel htmlFor="my-input">{t('phoneNumber')}</InputLabel>
                        <OutlinedInput
                          disabled={state.isPhoneDisabled}
                          id="phone"
                          inputComponent={PhoneInput}
                          name="phone"
                          value={state.phonenumber}
                          autoComplete="phone"
                          inputProps={{
                            placeholder: t('phonePlaceholder'),
                            defaultCountry: 'US',
                            addInternationalOption: false,
                            limitMaxLength: true,
                            style: {
                              display: 'inline-flex',
                              background: 'white',
                            },
                            numberInputProps: {
                              className: classes.phoneNumberInput,
                            },
                            onChange: (value) => {
                              return setState((prevState) => {
                                return { ...prevState, phonenumber: value };
                              });
                            },
                          }}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="email"
                        label={t('email')}
                        name="email"
                        autoComplete="email"
                        InputProps={{
                          className: classes.input,
                        }}
                        value={state.email}
                        onChange={(event) => {
                          const value = event.target.value;
                          return setState((prevState) => {
                            return { ...prevState, email: value };
                          });
                        }}
                        disabled={state.isEmailDisabled}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-password">{t('password')}</InputLabel>
                        <OutlinedInput
                          id="password"
                          type={showPassword ? 'text' : 'password'}
                          style={{ background: '#fff' }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                edge="end"
                              >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                          label={t('password')}
                          value={state.password}
                          onChange={(event) => {
                            const value = event.target.value;
                            return setState((prevState) => {
                              return { ...prevState, password: value };
                            });
                          }}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} style={{ display: 'grid' }}>
                      <FormLabel
                        id="demo-radio-buttons-group-label"
                        style={{ textAlign: 'left', fontSize: '17px', marginBlock: '10px' }}
                      >
                        {t('areYou')}
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-label="redirectToMainUser"
                        value={state.userType}
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="radio-buttons-group"
                        style={{ display: 'flex', justifyContent: 'center' }}
                        onChange={(event) => {
                          const value = event.target.value;
                          return setState((prevState) => {
                            return { ...prevState, userType: value };
                          });
                        }}
                      >
                        <FormControlLabel
                          value={careUserType.careRecipient}
                          control={<Radio />}
                          label={t('careRecipient')}
                          disabled={state.isRadioEmailDisabled}
                        />
                        <FormControlLabel
                          value={careUserType.cargiver}
                          control={<Radio />}
                          label={t('caregiver')}
                          disabled={state.isRadioEmailDisabled}
                        />
                      </RadioGroup>
                    </Grid>
                  </Grid>
                  <Typography className={classes.errorMessage} component="h1" variant="subtitle1">
                    {state.errorMessage}
                  </Typography>
                  <Grid container direction="row" justify="space-between" alignItems="center">
                    <Grid item>
                      <Link className={classes.goBackButton} variant="body2" to={'/login'}>
                        {t('alreadyHaveAccount')}
                      </Link>
                    </Grid>
                    <Button
                      disabled={loader}
                      variant="contained"
                      color="primary"
                      className={classes.submit}
                      onClick={() => {
                        if (state.phonenumber && state.phonenumber.length < 10) {
                          return setState((prevState) => {
                            return {
                              ...prevState,
                              errorMessage: t('phoneNumberDigits'),
                            };
                          });
                        } else {
                          return submitInfo();
                        }
                      }}
                    >
                      {loader ? t('submitting') : t('submit')}
                    </Button>
                  </Grid>
                  <Grid>
                    <LoginWithGoogle />
                  </Grid>
                </form>
              )}
              {state.welcome && (
                <div>
                  <form className={classes.form} noValidate>
                    <Grid container>
                      <Typography component="h1" className={classes.mainText} variant="h4">
                        {t('congratulations')}
                      </Typography>
                      <Typography component="h1" variant="subtitle1" className={classes.explanationText}>
                        {t('verificationSent', { email: state.email })}
                      </Typography>
                    </Grid>
                  </form>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={() => props.history('/login')}
                  >
                    {t('loginToAccount')}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default CanCareSignUp;
